import React from 'react';
import { Table, Tag, Tooltip, Alert, Typography, Divider } from 'antd';

const ACTION_TAG = {
  insert: { color: 'green', text: 'Nueva' },
  update: { color: 'blue', text: 'Actualiza' },
  error: { color: 'red', text: 'Error' },
};

const ImportPreviewTable = ({ result, columns }) => {
  const { rows = [], deactivations = [], summary } = result || {};

  const dataColumns = [
    { title: 'Fila', dataIndex: 'line', key: 'line', width: 70 },
    {
      title: 'Acción',
      dataIndex: 'action',
      key: 'action',
      width: 110,
      render: (a) => <Tag color={ACTION_TAG[a]?.color}>{ACTION_TAG[a]?.text}</Tag>,
    },
    ...columns
      .filter((c) => !c.readonly)
      .map((c) => ({
        title: c.label,
        dataIndex: ['data', c.key],
        key: c.key,
        render: (val, record) => {
          const err = (record.errors || []).find((e) => e.column === c.key);
          const text = typeof val === 'boolean' ? (val ? 'Sí' : '') : val;
          return err ? (
            <Tooltip title={err.message}>
              <Typography.Text type="danger" underline>
                {String(text ?? '')}
              </Typography.Text>
            </Tooltip>
          ) : (
            String(text ?? '')
          );
        },
      })),
  ];

  return (
    <div>
      {summary && (
        <Alert
          type={summary.errors ? 'warning' : 'info'}
          showIcon
          message={`${summary.inserts} nuevas · ${summary.updates} a actualizar · ${summary.deactivations} a desactivar · ${summary.errors} con error`}
          className="mb-3"
        />
      )}
      <Table
        rowKey="line"
        size="small"
        pagination={false}
        dataSource={rows}
        columns={dataColumns}
        scroll={{ y: 320 }}
      />
      {deactivations.length > 0 && (
        <>
          <Divider orientation="left">Se desactivarán (no están en el archivo)</Divider>
          <Table
            rowKey="id"
            size="small"
            pagination={false}
            dataSource={deactivations}
            columns={[
              { title: 'ID', dataIndex: 'id', width: 70 },
              { title: 'Actividad', dataIndex: 'label' },
            ]}
          />
        </>
      )}
    </div>
  );
};

export default ImportPreviewTable;
